// extracted by mini-css-extract-plugin
export var arrow = "CollectionSearchResults-module--arrow--65ac7";
export var arrowNo = "CollectionSearchResults-module--arrow_no--10a32";
export var arrowYes = "CollectionSearchResults-module--arrow_yes--d6977";
export var flex = "CollectionSearchResults-module--flex--318d2";
export var flex1 = "CollectionSearchResults-module--flex_1--75276";
export var flexCenter = "CollectionSearchResults-module--flex_center--d4fd3";
export var flexCenterCol = "CollectionSearchResults-module--flex_center_col--b7d00";
export var flexCol = "CollectionSearchResults-module--flex_col--3f606";
export var flexFixCenterCol = "CollectionSearchResults-module--flex_fix_center_col--7bd05";
export var flexFixedCenterCol = "CollectionSearchResults-module--flex_fixed_center_col--38a9d";
export var pageIndicator = "CollectionSearchResults-module--pageIndicator--bcb7d";
export var pageIndicatorText = "CollectionSearchResults-module--pageIndicatorText--e469d";
export var resultIndicatorText = "CollectionSearchResults-module--resultIndicatorText--212d9";
export var resultInformationRow = "CollectionSearchResults-module--resultInformationRow--698e0";
export var resultsIndicator = "CollectionSearchResults-module--resultsIndicator--7073d";
export var rotating = "CollectionSearchResults-module--rotating--59504";
export var searchResultsPagination = "CollectionSearchResults-module--searchResultsPagination--c8964";
export var sortResultsDropdownContainer = "CollectionSearchResults-module--sortResultsDropdownContainer--b8259";
export var sortResultsLabel = "CollectionSearchResults-module--sortResultsLabel--5aa0a";